import { toast } from "sonner";

export interface NotifyOptions {
  description?: string;
}

export const notify = {
  success: (message: string, options?: NotifyOptions) =>
    toast.success(message, options),
  error: (message: string, options?: NotifyOptions) =>
    toast.error(message, options),
  info: (message: string, options?: NotifyOptions) =>
    toast.info(message, options),
};
